import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

   export const getCashBookings = createAsyncThunk('appCashBooking/getCashBookings', async (GetCCDetails) => {
      
      const response = await axios.post('https://api.zasway.com:8443/Booking/GetTableSummaryCashBooking', GetCCDetails, {mode:'cors'})
       
      return response.data 
   })
   export const GetCashBookingsTotalAndRevenue = createAsyncThunk('appCashBooking/GetCashBookingsTotalAndRevenue', async (GetCCDetails) => {
       
      const response = await axios.post('https://api.zasway.com:8443/Booking/GetCashBookingsTotalAndRevenue', GetCCDetails, {mode:'cors'})
       
      return response.data 
   })
   export const sendReceipt = createAsyncThunk('appCashBooking/sendReceipt', async (ClientId) => {
      
      const response = await axios.post('https://api.zasway.com:8443/BookingInvoice/SendReceiptEmailCash', ClientId, {mode:'cors'})
       
      return response.data
    })
    export const GetEmails = createAsyncThunk('appPassenger/GetEmails', async (ClientId) => {
      
      const response = await axios.post('https://api.zasway.com:8443/Booking/GetBookingEmailAddresses', ClientId, {mode:'cors'})
       
      return response.data
    })
   export const AddCardPaymentTransaction = createAsyncThunk('appCashBooking/AddCardPaymentTransaction ', async (params) => {
          const response = await axios.post('https://api.zasway.com:8443/Client/AddPaymentTransaction', params, { mode: 'cors' })
         return response.data
         })

   export const getFinancialInfoDetails = createAsyncThunk('appCashBooking/getFinancialInfoDetails', async (GetCCDetails) => {
      
      const response = await axios.post('https://api.zasway.com:8443/Booking/GetTableSummaryCashBooking', GetCCDetails, {mode:'cors'})

      return response.data 
   })

   export const getBookingExpense = createAsyncThunk('appCashBooking/getBookingExpense', async (GetExpenseList) => {
      const response = await axios.post('https://api.zasway.com:8443/Booking/GetTableSummaryBookingExpense', GetExpenseList, {mode:'cors'})
      return response.data
   })
   export const getPassengerCardsList = createAsyncThunk('appCashBooking/getPassengerCardsList', async (params) => {
      
      const response = await axios.post('https://api.zasway.com:8443/Passenger/GetPassengerCreditCardList', params, {mode:'cors'})
        return response.data
    })

    export const getPassengerCardDetails = createAsyncThunk('appCashBooking/getPassengerCardDetails', async (params) => {
      
      const response = await axios.post('https://api.zasway.com:8443/Passenger/GetPassengerCreditCardDetails',  params, {mode:'cors'})

        return response.data
    })
    
   export const getInvoiceDue = createAsyncThunk('appDriverBookingExpense/getInvoiceDue', async (params) => {
    
      const response = await axios.post('https://api.zasway.com:8443/Client/InvoiceDeAmount', params, {mode:'cors'})
       
      return response.data 
  
      })
      export const getPaymentType = createAsyncThunk('appDriverBookingExpense/getPaymentType', async (params) => {

         const response = await axios.post('https://api.zasway.com:8443/Client/GetPaymentType', params, { mode: 'cors' })
           return response.data
       })
  export const getallpaymentInvoice = createAsyncThunk('appCardtransactions/getallpaymentInvoice', async (GetCCDetails) => {
            
   const response = await axios.post('https://api.zasway.com:8443/Client/AllPaymentsInvoice', GetCCDetails, {mode:'cors'})
   
   return response.data 

   })
   export const getFinancialInfotransaction = createAsyncThunk('appCashBooking/getFinancialInfotransaction', async (GetCCDetails) => {
      const response = await axios.post('https://api.zasway.com:8443/Booking/GetTableSummaryCashBooking', GetCCDetails, {mode:'cors'})
      return response.data 
   })

   export const getallpaymenttransactions = createAsyncThunk('appCashBooking/getallpaymenttransactions', async (GetCCDetails) => {
       
      const response = await axios.post('https://api.zasway.com:8443/PaymentTransaction/AllPaymentTransactions', GetCCDetails, {mode:'cors'})
       
      return response.data 
   })

   export const AddInvoicePaymentTransaction = createAsyncThunk('appDriverBookingExpense/AddInvoicePaymentTransaction ', async (params) => {
      
      // 
          const response = await axios.post('https://api.zasway.com:8443/Client/AddInvoicePaymentTransaction', params, { mode: 'cors' })
     
    
         return response.data
         })
         
  export const ClientPaymentAPI = createAsyncThunk('appDriverBookingExpense/ClientPaymentAPI ', async (params) => {
   // 
    
       const response = await axios.post('https://api.zasway.com:8443/Client/ClientPayment', params, { mode: 'cors' })
               
      return response.data
      })
   export const AddPaymentTransaction = createAsyncThunk('appCashBooking/AddPaymentTransaction ', async (params) => {
      const response = await axios.post('https://api.zasway.com:8443/PaymentTransaction/AddPaymentTransaction', params, { mode: 'cors' })
      return response.data
   })

   export const StripeAPI = createAsyncThunk('appCashBooking/StripeAPI ', async (params) => {
       
      const response = await axios.post('https://api.zasway.com:8443/PaymentTransaction/StripeTest', params, { mode: 'cors' })
       
      return response.data
   })

   export const GetPaymentStatus = createAsyncThunk('appCashBooking/GetPaymentStatus ', async (params) => {
      const response = await axios.post('https://api.zasway.com:8443/PaymentTransaction/GetPaymentStatus', params, { mode: 'cors' })
      return response.data
   })
   
   export const getClientList = createAsyncThunk('appCashBooking/getClientList', async (params) => {
      const response = await axios.post('https://api.zasway.com:8443/Common/GetClientList', params, { mode: 'cors' })
      return response.data
   })

   export const getClientListSecond = createAsyncThunk('appCashBooking/getClientListSecond', async (params) => {
      const response = await axios.post('https://api.zasway.com:8443/Common/GetClientList', params, { mode: 'cors' })
      return response.data
   })

   export const getTotalPayment = createAsyncThunk('appCashBooking/getTotalPayment', async (GetPayment) => {
      const response = await axios.post('https://api.zasway.com:8443/Booking/GetTableSummaryCashBooking', GetPayment, {mode:'cors'})
      return response.data 
   })
   export const UpdateParamState = createAsyncThunk('appBookingValidation/UpdateParamState', async (formData) => {
          
      const response = formData
   
      return response
    })
export const appCashBookingSlice = createSlice({
   name: 'appCashBooking',
   initialState: {
      data: [],
      paymentData: [],
      allData: [],
      cashBookingData: [],
      TotalBookingsRevenue: [],
      FilterState: false
   },
   reducers: {},
   extraReducers: builder => {
      builder
      .addCase(getCashBookings.fulfilled, (state, action) => {
          
         state.cashBookingData = action.payload
      })
      .addCase(getTotalPayment.fulfilled, (state, action) => {
         state.paymentData = action.payload.paymentData
      })
      .addCase(GetCashBookingsTotalAndRevenue.fulfilled, (state, action) => {
         
        state.TotalBookingsRevenue = action.payload
        
      })
      .addCase(UpdateParamState.fulfilled, (state, action) => {
         
         state.FilterState = action.payload.param
          
       })
     }
   })

export default appCashBookingSlice.reducer